import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethodPromise } from '@ngx-resource/core';

import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';

interface User {
    data: any;
}

@Injectable()
@ResourceParams({
    url: `${environment.url.adminLoginUrl}`
})
export class AdminRedirectService extends RestClient {

    @ResourceAction({
        path: 'pps/login',
        method: ResourceRequestMethod.Post
    })
    login: IResourceMethodPromise<{ username: any, password: any }, User>;
}
